import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { clearAnalysisReportsCache } from '../api/spend';
import { useAuthState } from './AuthProvider';

/** Drops Analysis PO / spend-MTO React Query cache when the session ends so data is not kept after logout. */
export function ClearAnalysisCacheOnLogout() {
  const state = useAuthState();
  const qc = useQueryClient();
  const prevStatusRef = useRef(state.status);

  useEffect(() => {
    const prev = prevStatusRef.current;
    prevStatusRef.current = state.status;
    if (prev === 'authenticated' && state.status === 'unauthenticated') {
      clearAnalysisReportsCache(qc);
    }
  }, [state.status, qc]);

  return null;
}
